/**
 * 以下文件全局引入，无需在页面内引入
 */
import dateTools from './dateTools'
import typeTools from './typeTools'
import utils from './utils'
export default {
  ...dateTools,
  ...typeTools,
  ...utils,
}
